import prefixedRoute from '../utils/prefixed-route'

export const CART_ENDPOINT = prefixedRoute('/api/v3/cart_items')
export const CATALOG_CATEGORY_ENDPOINT = (catalogId: number | string) =>
  prefixedRoute(`/api/v3/catalog_categories/${catalogId}/products`)
export const CHECKOUT_ENDPOINT = '/api/v3/dme_checkouts'
export const CUSTOMER_ENDPOINT = '/api/v3/dme_customers'
export const CURRENT_CUSTOMER_ENDPOINT = '/api/v3/dme_customers/current'
export const CUSTOMER_INSURANCES_ENDPOINT = '/api/v3/dme_customer_insurances'
export const CUSTOMER_PHYSICIAN_ENDPOINT = '/api/v3/dme_customer_physicians'
export const CUSTOMER_PHYSICIAN_DETAILS_ENDPOINT =
  '/api/v3/dme_customer_physician_details'
export const INSURANCE_CATALOG_ENDPOINT = '/api/v3/dme_insurances'
export const PHYSICIAN_SEARCH_ENDPOINT = (query: string) =>
  `/api/v3/dme_physicians?limit=200&${query}`
export const OTP_VERIFICATION_ENDPOINT =
  '/api/v3/dme_customers/otp_verifications'
export const OTP_CREATION_ENDPOINT = '/api/v3/dme_customers/otp'
export const MEMBER_CARD_CREATION_ENDPOINT = (orderId: number | string) =>
  `/api/v3/dme_orders/${orderId}/member_cards`
export const LEAD_CREATION_ENDPOINT = '/api/v3/dme_leads'
export const SUBSCRIPTION_PRODUCTS_ENDPOINT = (subscriptionId: string) =>
  `/api/v3/dme_subscriptions/${subscriptionId}/products`
export const VERIFY_CUSTOMER_INSURANCE_ENDPOINT = (
  phiCustomerInsuranceToken: string
) => `/api/v3/dme_customer_insurances/${phiCustomerInsuranceToken}/verify`
